import { memo } from "react";
import { Project_Base } from "~/common/typescript/models/Project";
import { AC_Project_Base } from "~/common/typescript/services/access_control/AC_Project";
import ProjectItem from "../ProjectItem/ProjectItem";

export type ACProjectItemType = {
  acProject?: AC_Project_Base;
  project?: Project_Base;
  key?: string | number;
};

const ACProjectItem = (props: ACProjectItemType) => {
  const sourceProject = props.acProject?.project || props.project;
  if (!sourceProject) return null;

  return (
    <ProjectItem
      project={sourceProject}
      role={props.acProject?.role}
    />
  );
};

export default memo(ACProjectItem);